module.exports = __webpack_public_path__ + "assets/img/2.d4211214.png";